export const VALIDATE_PURCHASE_REQUEST = 'VALIDATE_PURCHASE_REQUEST';
export const VALIDATE_PURCHASE_SUCCESS = 'VALIDATE_PURCHASE_SUCCESS';
export const VALIDATE_PURCHASE_FAILURE = 'VALIDATE_PURCHASE_FAILURE';
